
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timestamp/en",
      function () {
        return require("private-next-pages/timestamp/en/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timestamp/en"])
      });
    }
  